import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M14.64 4.337a.75.75 0 0 1-.895-.57l-.264-1.19a.75.75 0 1 1 1.464-.325l.264 1.19a.75.75 0 0 1-.569.895M18.222 4.967a.75.75 0 0 1-.23-1.035l.655-1.03a.75.75 0 0 1 1.265.806l-.655 1.029a.75.75 0 0 1-1.035.23M10.403 4.734A.75.75 0 1 0 9.597 6l1.032.656a.75.75 0 1 0 .805-1.265z" />
    <path
      fillRule="evenodd"
      d="M18.373 11.88a4 4 0 1 0-6.74-3.41 7 7 0 0 0-1.36-.133c-3.195 0-5.906 2.175-6.473 5.113-1.473.55-2.55 1.918-2.55 3.562 0 2.153 1.837 3.825 4.01 3.825h10.39c2.775 0 5.1-2.133 5.1-4.854 0-1.746-.957-3.25-2.377-4.103m-1.658-.643q-.465-.096-.958-.106a6.5 6.5 0 0 0-2.659-2.19 2.5 2.5 0 1 1 3.617 2.296M5.217 14.108c.253-2.364 2.387-4.271 5.056-4.271 1.921 0 3.576.994 4.438 2.437a.75.75 0 0 0 .691.364q.123-.008.248-.008c2.03 0 3.6 1.542 3.6 3.353s-1.57 3.354-3.6 3.354H5.26c-1.428 0-2.51-1.082-2.51-2.325 0-1.057.776-1.992 1.892-2.253a.75.75 0 0 0 .575-.65"
      clipRule="evenodd"
    />
    <path d="M19.68 11.527a.75.75 0 0 1 1.035-.23l1.03.655a.75.75 0 1 1-.806 1.265l-1.03-.655a.75.75 0 0 1-.23-1.035M20.31 7.945a.75.75 0 0 1 .569-.895l1.19-.264a.75.75 0 1 1 .326 1.464l-1.19.265a.75.75 0 0 1-.895-.57" />
  </>
);

const Weather30 = Icon('weather-30', svgContents);

export default Weather30;
